// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 761 ? "copilot" : chunkId) + "." + {"243":"3c95e2b0","453":"a63d4ca6","761":"cdf4676b"}[chunkId] + ".chunk.js";
};